ShortcutHeader = window.ShortcutHeader = {}

class ShortcutHeader.EventHandler
  #Buffer to give some breathing space below the shortcut bar
  TOP_BUFFER = 10

  constructor: (config, eventExtends) ->
    {@onSectionScroll, @onShortcutClick} = eventExtends if eventExtends
    {@stickyWatchElements, @shortcutMap, @stickyClass, animationConfig} = config
    @$headers = $ '#shortcut-header'

    @setDefaults(animationConfig)

  setDefaults: (config)->
    @tickInterval = config?.tickInterval or 15
    @visibleFactor = config?.visibleFactor or 100
    @scrollDelay = config?.scrollDelay or 20
    @stickyClass ?= 'fixed'
    @elemSelected = false

  _getTopPosition: (target) ->
    $target = $(target)
    $target.offset().top - @_offsetHeight() + TOP_BUFFER if $target.length

  _isSectionInViewport: (el) ->
    rect = el[0]?.getBoundingClientRect()
    offset = @_offsetHeight() + @visibleFactor
    rect?.bottom >= offset

  _offsetHeight: ->
    height = 0
    index = 0
    stickyElements = $(".#{@stickyClass}")
    len = stickyElements.length
    while index < len
      bottom = stickyElements[index].getBoundingClientRect().bottom
      height = bottom if bottom > height
      index++

    height

  navigateTargetSection: (target, callback) ->
    initial = $(window).scrollTop()
    final = @_getTopPosition(target)

    difference = Math.abs(final - initial)
    duration = difference / 10 + 100
    increment = Math.ceil(difference * @tickInterval / duration)
    current = initial

    stepAnimator = =>
      if Math.abs(current - final) < increment
        current = final
      else if current < final
        current = current + increment
      else
        current = current - increment

      window.scrollTo(0, current)

      if current isnt final
        final = @_getTopPosition(target) or final
        setTimeout stepAnimator, @tickInterval
      else
        callback()

    stepAnimator()

  processShortcutSelection: (el, ev) ->
    $el = $ el
    targetSection = @shortcutMap?[$el.attr('id')]
    @elemSelected = true

    @navigateTargetSection targetSection, =>
      @elemSelected = false

    @$headers.find('.shortcut-group li').removeClass "selected"
    $el.addClass "selected"

    @onShortcutClick?($el)
    ev?.preventDefault()

  stickHeader: (watchElement) ->
    offset = 0
    isFixed = false

    if _.isObject(watchElement)
      $watchElement = $(watchElement.elem)
      watchParentOffset = $(watchElement.parent).height()
    else
      $watchElement = $(watchElement)

    return unless $watchElement and $watchElement.offset()

    offsetTop = $watchElement.offset().top - offset

    processStickHeader = ->
      scrollTop = $(window).scrollTop()
      watchParentOffset = $(watchElement.parent).height() unless watchParentOffset?
      offsetTop = $watchElement.offset().top - (watchParentOffset ? 0) unless isFixed

      shouldBeFixed = scrollTop > offsetTop
      if shouldBeFixed and not isFixed
        isFixed = true
        $watchElement.trigger("stickElement", {offset: watchParentOffset ? 0})
      else if not shouldBeFixed and isFixed
        isFixed = false
        $watchElement.trigger("unstickElement", [])

    throttled = _.throttle processStickHeader, @scrollDelay
    $(window).on "scroll", throttled

  updateShortcutSelection: =>
    for shortcutId of @shortcutMap
      contentId = @shortcutMap[shortcutId]
      $el = $ contentId
      if not @elemSelected and $el.length is 1 and @_isSectionInViewport($el)
        @$headers.find('.shortcut-group li').removeClass "selected"
        @$headers.find(".#{shortcutId}").addClass "selected"
        @onSectionScroll?($el)
        break

    return

  activate: ->
    if @$headers.find('.shortcut-group li.selected').length is 0
      @$headers.find('.shortcut-group li:first').addClass "selected"

    layout = this
    @$headers.find('.shortcut-group li').on "click", (ev) ->
      layout.processShortcutSelection($(this), ev)

    for elem of @stickyWatchElements
      @stickHeader @stickyWatchElements[elem]

    processShortcutSelection = _.throttle @updateShortcutSelection, @scrollDelay
    $(window).on "resize scroll", processShortcutSelection


module.exports = ShortcutHeader
